import Lenis from 'lenis'
import { appSettings } from '../context';

class Scroll {
    lenis: any;
    settings: any;
    constructor(settings?: any) {
        const defaultSettings = {
            scroller: appSettings.scroller,
            smoothness: appSettings.scrollSmoothness,
        }

        this.settings = { ...defaultSettings, ...settings }
    }

    init() {
        this.lenis = new Lenis({
            wrapper: this.settings.scroller,
            lerp: (100 - this.settings.smoothness) / 100,
        })

        this.lenis.on('scroll', (e: any) => {
            document.dispatchEvent(new CustomEvent('hg:scroll', { detail: e }))
            ScrollTrigger.update()
        })
        
        gsap.ticker.add((time: number) => {
            this.lenis.raf(time * 1000)
        })
        
        gsap.ticker.lagSmoothing(0)
    }
}

export default Scroll

